const queries = {
  itemToItems: getItemToItemsQuery,
  userToItems: getUserToItemsQuery,
  topProd: getTopProdQuery,
};

function getItemToItemsQuery() {
  return `query itemToItems(
    $locale: String,
    $itemId: String,
    $itemCount: Int,
    $dataSource: String,
    $modelId: String,
    $stockLevel: Int,
    $fusionExperimentVariant: String
) {
  itemToItems(
        locale: $locale,
        itemId: $itemId,
        itemCount: $itemCount,
        dataSource: $dataSource,
        modelId: $modelId,
        stockLevel: $stockLevel,
        fusionExperimentVariant: $fusionExperimentVariant
    ) `;
}

function getUserToItemsQuery() {
  return `query userToItems(
    $locale: String,
    $userId: String,
    $itemCount: Int,
    $dataSource: String,
    $modelId: String,
    $fallback: Boolean
) {
  userToItems(
        locale: $locale,
        userId: $userId,
        itemCount: $itemCount,
        dataSource: $dataSource,
        modelId: $modelId,
        fallback: $fallback
    ) `;
}

function getTopProdQuery() {
  return `query topProd(
      $locale: String,
      $itemCount: Int,
  ) {
    topProd(
          locale: $locale,
          itemCount: $itemCount,
      ) `;
}

export const RECOMMENDER_BASE = (queryLabel) => {
  const getQuery = queries[queryLabel];
  return !!getQuery ? getQuery() : "";
};

export const REC_QUERY = () => `{
    id
    type
    products {
      id
      skuId
      productId
      displayName
      productOnSale
      listPrice
      salePrice
      currencyCode
      pdpUrl
      skuImages
      skuStyleNumber
      skuStyleOrder {
        id
        skuStyleOrderId
        colorId
        styleId
        styleId01
        styleId02
        colorGroup
        colorName
      }
      swatches {
        id
        name
        imageUrl
        styleId
      }
    }
    count
    fusionExperimentId
    fusionExperimentVariant
    fusionQueryId
    link
    meta {
      version
      timestamp
    }
    recFallback
    recsPerPage
    totalNumRecs
    legacyJSON
  }
}
`;
